import api from '../../../app/api';
import { arrayToQueryParams } from '../../../shared/utils/array-to-query-params';
import { DashboardStatistics } from '../models/dashboard-statistics';
import { SignDocumentCount } from '../models/sign-document-count';
import { TemplateSignTime } from '../models/template-sign-time';

export const dashboardApi = api
  .enhanceEndpoints({
    addTagTypes: ['SignRequests', 'ScanRequests'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getDashboardSignRequests: builder.query<
        DashboardStatistics,
        {
          clientUsers?: string[];
          dateFrom?: string;
          dateTo?: string;
          template?: string;
        }
      >({
        query: ({ clientUsers, dateFrom, dateTo, template }) => ({
          url: '/portal-api/v1/dashboard/documents',
          method: 'GET',
          params: {
            ...arrayToQueryParams(clientUsers || [], 'clientUsers'),
            dateFrom,
            dateTo,
            template,
          },
        }),
        providesTags: ['SignRequests'],
      }),
      getDashboardScanRequests: builder.query<
        DashboardStatistics,
        {
          clientUsers?: string[];
          dateFrom?: string;
          dateTo?: string;
        }
      >({
        query: ({ clientUsers, dateFrom, dateTo }) => ({
          url: '/portal-api/v1/dashboard/scans',
          method: 'GET',
          params: {
            ...arrayToQueryParams(clientUsers || [], 'clientUsers'),
            dateFrom,
            dateTo,
          },
        }),
        providesTags: ['ScanRequests'],
      }),
      getSignedDocumentsByUser: builder.query<SignDocumentCount[], void | { dateFrom?: string; dateTo?: string }>({
        query: args => ({
          url: '/portal-api/v1/dashboard/users',
          params: args ?? {},
        }),
        providesTags: [],
      }),
      getSignedDocumentsByTemplates: builder.query<TemplateSignTime[], void | { dateFrom?: string; dateTo?: string }>({
        query: args => ({
          url: '/portal-api/v1/dashboard/templates/sign-time',
          params: args ?? {},
        }),
        providesTags: [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useLazyGetDashboardSignRequestsQuery,
  useLazyGetDashboardScanRequestsQuery,
  useLazyGetSignedDocumentsByUserQuery,
  useLazyGetSignedDocumentsByTemplatesQuery,
} = dashboardApi;
